import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "integrations-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M9.28653 9.22981C9.28653 8.8156 8.95074 8.47981 8.53653 8.47981C8.12232 8.47981 7.78653 8.8156 7.78653 9.22981V11.3077C7.78653 11.7219 8.12232 12.0577 8.53653 12.0577C8.95074 12.0577 9.28653 11.7219 9.28653 11.3077V9.22981Z" }, null, -1),
    _createElementVNode("path", { d: "M12.75 14.0778C12.75 13.6636 12.4142 13.3278 12 13.3278C11.5858 13.3278 11.25 13.6636 11.25 14.0778V16.1557C11.25 16.5699 11.5858 16.9057 12 16.9057C12.4142 16.9057 12.75 16.5699 12.75 16.1557V14.0778Z" }, null, -1),
    _createElementVNode("path", { d: "M15.4634 8.47981C15.8776 8.47981 16.2134 8.8156 16.2134 9.22981V11.3077C16.2134 11.7219 15.8776 12.0577 15.4634 12.0577C15.0492 12.0577 14.7134 11.7219 14.7134 11.3077V9.22981C14.7134 8.8156 15.0492 8.47981 15.4634 8.47981Z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12 2.24622C6.61312 2.24622 2.24622 6.61312 2.24622 12C2.24622 17.3868 6.61312 21.7537 12 21.7537C17.3868 21.7537 21.7537 17.3868 21.7537 12C21.7537 6.61312 17.3868 2.24622 12 2.24622ZM3.74622 12C3.74622 7.44155 7.44155 3.74622 12 3.74622C16.5584 3.74622 20.2537 7.44155 20.2537 12C20.2537 16.5584 16.5584 20.2537 12 20.2537C7.44155 20.2537 3.74622 16.5584 3.74622 12Z"
    }, null, -1)
  ])))
}
export default { render: render }